import type { CampaignType } from '@features/campaign-list';
import type { Advertiser, Client } from '@features/clients';

export type ExportFilterState = {
  selectedClient: Client | null;
  selectedAdvertiser: Advertiser | null;
  selectedCampaignType: CampaignType;
  searchText: string;
};

export const exportFilterInitialState = {
  selectedClient: null,
  selectedAdvertiser: null,
  selectedCampaignType: 'all',
  searchText: '',
} as const satisfies ExportFilterState;
